module.exports = __webpack_public_path__ + "static/img/电子回单.3f64bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/电子回单.png
// module id = Q/fe
// module chunks = 2